import CertificatesInPledge from './CertificatesInPledge'

export default CertificatesInPledge
